export default "__VITE_ASSET__BFjnwpaa__"